module.exports = __webpack_public_path__ + "img/complexe_desjardins.feaa8001.webp";